import { RootInitialState } from 'core/common/store/rootReducer';

export const getUserInteraction = (state: RootInitialState) => {
  return state.userInteraction;
};

export const getIsVideoSoundEnabled = (state: RootInitialState) => {
  return state.userInteraction.isVideoSoundEnabled;
};
